import React from "react";
import { Link } from "gatsby";
import cx from "classnames";

// navItems: [{ slug, heading, subsections: [{ label, id }] }], built in
// gatsby-node.js from the Markdown and Prismic explainer pages together.
// Only the current page lists its subsections, so the navigation stays
// readable as pages are added.
function SideNav({ navItems, currentSlug, currentItem }) {
  return (
    <nav
      aria-label="Schengen guides"
      className="sidenav md:sticky top-10 md:w-4/12 pl-2 md:pl-4 pr-6 md:pb-6 mb-8 md:mb-16 md:mt-20 border-l-2 border-gold"
    >
      {navItems.map((item) => {
        const isCurrent = item.slug === currentSlug;

        return (
          <div className="mb-2 md:mb-4 last:mb-0" key={item.slug}>
            <Link
              to={`/${item.slug}/`}
              className={cx(
                "block text-base uppercase font-semibold hover:text-gold mb-2",
                { "text-gold": isCurrent }
              )}
            >
              {item.heading}
            </Link>
            {isCurrent && (
              <ul className="hidden md:block">
                {item.subsections.map((subItem) => (
                  <li
                    className={cx(
                      "text-sm text-charcoal hover:font-semibold mb-2",
                      {
                        "font-semibold active-item":
                          currentItem === `#${subItem.id}`,
                      }
                    )}
                    key={subItem.id}
                  >
                    <Link to={`/${item.slug}/#${subItem.id}`}>
                      {subItem.label}
                    </Link>
                  </li>
                ))}
              </ul>
            )}
          </div>
        );
      })}
    </nav>
  );
}

export default SideNav;
